export class LifeCalculatorSubmissionModel {
    firstName: string;
    lastName: string;
    zipCode: string;
    email: string;
    dependents: string;
    numberOfChildren: number;
    youngestChildAge: number;
    amountOfIncomeReplaced: number;
    yearsToSupportFamily: number;
    amountToSaveForEducation: number;
    annualIncome: number;
    isHomeowner: boolean;
    isClient: boolean;
    hasLifeInsurance: boolean;
    isPayingForChildrenEducation: boolean;
    monthlyRent: number;
    mortgage: number;
    debt: {
        other: number;
    };
    finalExpenses: number;
    currentCoverage: number;
    agentACID: string;
    sessionId: string;
    submissionId: string;

    constructor(agentACID: string, sessionId: string, submissionId: string) {
        this.firstName = "";
        this.lastName = "";
        this.zipCode = "";
        this.email = "";
        this.dependents = "";
        this.numberOfChildren = 0;
        this.youngestChildAge = 0;
        this.amountOfIncomeReplaced = 0;
        this.yearsToSupportFamily = 0;
        this.amountToSaveForEducation = 0;
        this.annualIncome = 0;
        this.isHomeowner = false;
        this.isClient = false;
        this.hasLifeInsurance = false;
        this.isPayingForChildrenEducation = false;
        this.monthlyRent = 0;
        this.mortgage = 0;
        this.debt = {
            other: 0
        };
        this.finalExpenses = 0;
        this.currentCoverage = 0;
        this.agentACID = agentACID;
        this.sessionId = sessionId;
        this.submissionId = submissionId;
    }
};